import React, { FC, Dispatch, SetStateAction, SyntheticEvent } from 'react'
import { Box, Tab } from '@mui/material'
import { useLocation } from 'react-router-dom'
import theme from 'theme'

/* Utils */
import { a11yProps } from '../../cpi-details/components/LibraryDetailsTabPanel'

/* Components */
import { HeaderContainer } from './insightsHeader.styles'
import { LibraryDetailsHoverTooltip } from '../../../components/tooltip/LibraryDetailsTooltip'
import { IntegrationsTabs } from '../../settings/integrations/integrations.styles'
import InsightsSearch from './InsightsSearch'
import ToolbarComponent from '../../../components/header/ToolbarComponent'
import ThemeButton from '../../../components/buttons/primary/ThemeButton'
import TrendsFilterIconDefault from '../../../components/svg/coverage-analyzer/TrendsFilterIconDefault'

interface Props {
  tabValue: number
  handleTabChange: (event: SyntheticEvent, newValue: number) => void
  title: string
  tabLabels: string[]
  hideIntegrationsTabs?: boolean
  loading?: boolean
  search: string
  setSearch: Dispatch<SetStateAction<string>>
  setFiltersToolbarOpen: Dispatch<SetStateAction<boolean>>
  filtersToolbarOpen: boolean
  filtersActive: boolean
  hideFilters?: boolean
}

const InsightsHeader: FC<Props> = ({
  tabValue,
  handleTabChange,
  title,
  loading,
  tabLabels,
  hideIntegrationsTabs,
  search,
  setSearch,
  setFiltersToolbarOpen,
  filtersToolbarOpen,
  filtersActive,
  hideFilters
}) => {
  const location = useLocation()

  return (
    <ToolbarComponent className="insights-header">
      <HeaderContainer className="insights-header-container">
        <Box className="header-content-container">
          <Box className="search-container">
            <InsightsSearch search={search} setSearch={setSearch} placeholder="Search by Insight text or CPI" />
          </Box>

          <Box className="date-select-container">
            {!hideFilters && (
              <ThemeButton
                themevariant={filtersToolbarOpen ? 'ghost' : 'secondary'}
                onClick={() => setFiltersToolbarOpen(!filtersToolbarOpen)}
                noActive
                sx={{
                  minWidth: '118px !important',
                  padding: '0 !important',
                  display: 'flex !important',
                  justifyContent: 'center !important',
                  alignItems: 'center !important',
                  '&:focus': { color: '#fa75df !important' },
                  "html[data-theme='light'] &:focus": {
                    color: filtersToolbarOpen
                      ? `${theme.colors.surfaceContainerBackground} !important`
                      : `${theme.colors.menuItemText} !important`
                  }
                }}
              >
                <>
                  {!filtersActive ? (
                    <TrendsFilterIconDefault />
                  ) : (
                    <Box className="filter-icon-block">
                      <TrendsFilterIconDefault />
                      <Box className="active-circle">
                        <Box className="circle" />
                      </Box>
                    </Box>
                  )}
                  Filters
                </>
              </ThemeButton>
            )}
            {/*            <IconButton
              onClick={() => setFiltersToolbarOpen(!filtersToolbarOpen)}
              sx={{
                background: filtersToolbarOpen ? theme.baseColors.primary[20] : '',
                position: 'relative',

                '&:hover': {
                  background: theme.baseColors.primary[20],
                  svg: {
                    path: {
                      fill: theme.colors.white
                    }
                  }
                }
              }}
            >
              {filtersActive ? (
                <>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M5.702 4.5H18.202L11.9395 12.375L5.702 4.5ZM2.2645 4.0125C4.7895 7.25 9.452 13.25 9.452 13.25V20.75C9.452 21.4375 10.0145 22 10.702 22H13.202C13.8895 22 14.452 21.4375 14.452 20.75V13.25C14.452 13.25 19.102 7.25 21.627 4.0125C22.2645 3.1875 21.677 2 20.6395 2H3.252C2.2145 2 1.627 3.1875 2.2645 4.0125Z"
                      fill={filtersToolbarOpen ? theme.colors.white : theme.colors.textPrimary}
                    />
                  </svg>

                  <Box className="active-circle">
                    <Box className="circle" />
                  </Box>
                </>
              ) : (
                <>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M5.702 4.5H18.202L11.9395 12.375L5.702 4.5ZM2.2645 4.0125C4.7895 7.25 9.452 13.25 9.452 13.25V20.75C9.452 21.4375 10.0145 22 10.702 22H13.202C13.8895 22 14.452 21.4375 14.452 20.75V13.25C14.452 13.25 19.102 7.25 21.627 4.0125C22.2645 3.1875 21.677 2 20.6395 2H3.252C2.2145 2 1.627 3.1875 2.2645 4.0125Z"
                      fill={filtersToolbarOpen ? theme.colors.white : theme.colors.textPrimary}
                    />
                  </svg>
                </>
              )}
            </IconButton> */}
          </Box>
        </Box>

        {!hideIntegrationsTabs && (
          <IntegrationsTabs
            value={tabValue}
            onChange={handleTabChange}
            aria-label={`${title} tabs`}
            TabIndicatorProps={{
              style: { display: 'none' }
            }}
            isdetails="true"
          >
            {tabLabels.map((label, index) => {
              if (label === 'Data Sources' && location.pathname === '/asset-coverage-analyzer') {
                return (
                  <LibraryDetailsHoverTooltip key={index} title="Enabled data sources to analyze">
                    <Tab label={label} {...a11yProps(index)} />
                  </LibraryDetailsHoverTooltip>
                )
              }

              return <Tab label={label} {...a11yProps(index)} key={index} disabled={loading} />
            })}
          </IntegrationsTabs>
        )}
      </HeaderContainer>
    </ToolbarComponent>
  )
}

export default InsightsHeader
